import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { IoIosArrowForward } from 'react-icons/io'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  arrow: {
    position: 'absolute',
    padding: '12px',
    fontSize: '28px',
    display: 'block',
    height: '50px',
    width: '50px',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    right: '-2%',
    top: '15%',
  },
}))

export default function CustomSlider({ children }) {
  const classes = useStyles()

  const NextArrow = ({ onClick }) => {
    return (
      <div className={` ${classes.arrow}`} onClick={onClick}>
        <IoIosArrowForward />
      </div>
    )
  }

  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    accessibility: true,
    swipe: true,
    autoplay: true,
    // arrows: arrows ? false : true,
    autoplaySpeed: 1000,
    nextArrow: <NextArrow />,

    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  }

  return <Slider {...settings}>{children}</Slider>
}
